import { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import {
  FETCH_COMPANIES,
  FETCH_COMPANIES_2,
  FETCH_COMPANIES_PRODUCTS,
  FETCH_COMPANIES_TRADES,
  FETCH_PROJECT_SITE_COMPANIES,
  FETCH_PROJECTS_COMPANIES,
  GET_PROJECT_COMPANY_ROLES,
  SAVE_COMPANIES,
  SAVE_COMPANIES_TRADES,
  SAVE_COMPANY_PRODUCT,
  SAVE_PROJECTS_COMPAINES,
  SAVE_SITE_COMPANIES
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import { Getrequestcall } from "../../request/Getrequest";
import { English } from "../../constant/EnglishFallback";
import CloseIcon from "@mui/icons-material/Close";
import SearchField from "./SearchField";
import Removeduplicates from "./Removeduplicate";
import Loader from "../../common/Loader";

const AddCompanyWithRole = ({ open, onClose, title, mainId, onDataSave, from }) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const debounceTimeout = useRef(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [roleSearchTerm, setRoleSearchTerm] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [roleOptions, setRoleOptions] = useState([]);
  const [showOtherRoleInput, setShowOtherRoleInput] = useState(false);
  const [otherRoleTerm, setOtherRoleTerm] = useState("");

  const [submitLoader, setSubmitLoader] = useState(false);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isRoleLoading, setIsRoleLoading] = useState(false);
  const [searchFlag, setSearchFlag] = useState(true);

  const {
    BUTTON_ADD = English?.AddCompanyWithRole?.BUTTON_ADD,
    TEXT_COMPANIES = English?.AddCompanyWithRole?.TEXT_COMPANIES,
    TEXT_ROLE = English?.AddCompanyWithRole?.TEXT_ROLE,
    TEXT_SELECT_ROLE_OPTIONAL = English?.AddCompanyWithRole?.TEXT_SELECT_ROLE_OPTIONAL,
    TEXT_NEW_ROLE = English?.AddCompanyWithRole?.TEXT_NEW_ROLE,
    BUTTON_CANCEL = English?.AddCompanyWithRole?.BUTTON_CANCEL,
    TEXT_COMPANY_NAME = English?.AddCompanyWithRole?.TEXT_COMPANY_NAME,
    TEXT_SUBMIT = English?.AddCompanyWithRole?.TEXT_SUBMIT
  } = multiLanguageData?.AddCompanyWithRole || {};

  useEffect(() => {
    if (from !== "trade") {
      getRoles();
    }
  }, []);

  const getRoles = async () => {
    try {
      setIsRoleLoading(true);
      let res = await Getrequestcall(GET_PROJECT_COMPANY_ROLES, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      let a = [];
      const companyRoleData = resData.map((value) => {
        a = value;
        a["label"] = value.name;
        return a;
      });
      setRoleOptions(companyRoleData);
      setIsRoleLoading(false);
    } catch (error) {
      console.log("getRoles-> Error While Gettig Project Company Role: ", error);
      setIsRoleLoading(false);
    }
  };

  const checkCompanyAlreadyExistInData = async (item) => {
    try {
      let obj = {};
      let url = "";
      if (from === "trade") {
        obj = {
          PageNr: 1,
          NrOfRecPerPage: 20,
          FullSearch: searchTerm ?? "",
          SearchList: [
            {
              TradeId: mainId,
              companyId: item
            }
          ],
          userId: currentUserId,
          IncludeRecordNr: true,
          SortList: [{ FieldName: "CompanyName", Direction: "ASC" }],
          FetchAllowedRecordsOnly: true,
          TypeOfObjectReturned: ""
        };
        url = FETCH_COMPANIES_TRADES;
      } else if (from === "product") {
        obj = {
          PageNr: 1,
          NrOfRecPerPage: 20,
          FullSearch: "",
          SearchList: [
            {
              productId: mainId,
              companyId: item
            }
          ],
          userId: currentUserId,
          IncludeRecordNr: true,
          SortList: [{ FieldName: "CompanyName", Direction: "ASC" }],
          FetchAllowedRecordsOnly: true,
          TypeOfObjectReturned: ""
        };
        url = FETCH_COMPANIES_PRODUCTS;
      } else if (from === "project") {
        obj = {
          PageNr: 1,
          NrOfRecPerPage: 20,
          FullSearch: searchTerm ?? "",
          SearchList: [
            {
              projectId: mainId,
              companyId: item
            }
          ],
          userId: currentUserId,
          IncludeRecordNr: true,
          SortList: [{ FieldName: "CompanyName", Direction: "ASC" }],
          FetchAllowedRecordsOnly: true,
          TypeOfObjectReturned: ""
        };
        url = FETCH_PROJECTS_COMPANIES;
      } else if (from === "SiteCard") {
        obj = {
          PageNr: 1,
          NrOfRecPerPage: 20,
          FullSearch: "",
          UserId: currentUserId,
          IncludeRecordNr: true,
          TypeOfObjectReturned: "",
          FetchAllowedRecordsOnly: true,
          SearchList: [
            {
              SiteId: mainId,
              companyId: item
            }
          ],
          SortList: [{ FieldName: "DateCreated", Direction: "DESC" }]
        };
        url = FETCH_PROJECT_SITE_COMPANIES;
      }
      const res = await Postrequestcall(url, obj, loginData?.accessToken);

      const resData = res?.data?.data;
      return resData?.length !== 0 ? true : false;
    } catch (error) {
      console.log("checkCompanyAlreadyExistInData-> Error While Searching For Data: ", error);
      return false;
    }
  };

  const saveCompanyToRecord = async (companyId) => {
    try {
      setSubmitLoader(true);
      const fromCompanyAlreadyExists = await checkCompanyAlreadyExistInData(companyId);
      if (fromCompanyAlreadyExists) {
        setSubmitLoader(false);
        return alert("Company already added");
      }
      let obj = {};
      let url = "";
      if (from === "trade") {
        obj = {
          UserId: Number(currentUserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              CompanyId: companyId,
              TradeId: mainId,
              RecordStatusId: 1,
              ModifiedBy: Number(currentUserId)
            }
          ]
        };
        url = SAVE_COMPANIES_TRADES;
      } else if (from === "project") {
        obj = [
          {
            Id: 0,
            ProjectId: Number(mainId),
            CompanyId: companyId,
            ModifiedBy: Number(currentUserId),
            ProjectCompanyRoleId: selectedRole?.id,
            OtherProjectCompanyRole: otherRoleTerm
          }
        ];
        url = SAVE_PROJECTS_COMPAINES;
      } else if (from === "SiteCard") {
        obj = [
          {
            Id: 0,
            SiteId: mainId,
            CompanyId: companyId,
            ModifiedBy: Number(currentUserId)
          }
        ];
        url = SAVE_SITE_COMPANIES;
      } else if (from === "product") {
        obj = {
          UserId: Number(currentUserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              CompanyId: companyId,
              ProductId: mainId,
              RecordStatusId: 1,
              ModifiedBy: Number(currentUserId)
            }
          ]
        };
        url = SAVE_COMPANY_PRODUCT;
      }
      await Postrequestcall(url, obj, loginData?.accessToken);
      onDataSave();
      setSubmitLoader(false);
    } catch (error) {
      console.log("saveCompanyToRecord-> Error While Saving Data: ", error);
      setSubmitLoader(false);
    }
  };

  const onSaveClick = async () => {
    try {
      setSubmitLoader(true);
      if (selectedCompany?.id !== 0) {
        saveCompanyToRecord(selectedCompany?.id);
      } else {
        const saveObject = {
          userId: Number(currentUserId),
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: [
            {
              Id: 0,
              Name: searchTerm,
              ModifiedBy: Number(currentUserId),
              RecordStatusId: 1,
              Manufacturer: false
            }
          ]
        };
        let res = await Postrequestcall(SAVE_COMPANIES, saveObject, loginData?.accessToken);
        saveCompanyToRecord(res?.data?.data?.[0]?.objData?.id ?? 0);
      }
    } catch (error) {
      setSubmitLoader(false);
      console.log("onSaveClick-> Error While Saving Company: ", error);
    }
  };

  const getData = async (searchTerm) => {
    try {
      setIsLoading(true);
      
      // OLD API: FETCH_COMPANIES (commented, do not delete)
      // const obj = {
      //   PageNr: 1,
      //   NrOfRecPerPage: 20,
      //   IncludeRecordNr: true,
      //   SearchList: [
      //     {
      //       name: searchTerm,
      //       manufacturer: false
      //     }
      //   ],
      //   SortList: [{ FieldName: "Name", Direction: "ASC" }],
      //   FetchAllowedRecordsOnly: true,
      //   DoNotSearchInSystemFields: true
      // };
      // const res = await Postrequestcall(FETCH_COMPANIES, obj, loginData?.accessToken);
      
      // NEW API: FETCH_COMPANIES_2 (active)
      const obj = {
        UserId: currentUserId,
        SearchString: searchTerm,
        PageNumber: 1,
        PageSize: 20,
        Manufacturer: false,
        Id: 0
      };
      const res = await Postrequestcall(FETCH_COMPANIES_2, obj, loginData?.accessToken);
      let resData = res?.data?.data ?? [];
      const updatedCode = Removeduplicates(resData, "name");
      setData(() => updatedCode);
    } catch (error) {
      console.log("getData-> Error While Fetching Company: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const showAddBtn = (value) => {
    const searchData = data.filter((i) => i.name.toUpperCase() === value.toUpperCase());
    return searchData?.length === 0 ? true : false;
  };

  const onViewClick = (item) => {
    if (!item?.id) return null;
    setSelectedCompany(item);
    setSearchFlag(false);
    setSearchTerm(item?.name);
  };

  const onNewCompany = (item) => {
    setSelectedCompany({
      id: 0,
      name: item
    });
    setSearchTerm(item);
    setSearchFlag(false);
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={() => onClose()}>
            <CloseIcon />
          </IconButton>
        </Box>
        {isRoleLoading ? (
          <Box
            sx={{
              height: "470px",
              overflow: "auto"
            }}>
            <Loader />
          </Box>
        ) : (
          <>
            <Stack spacing={1.5} pt={1}>
              <SearchField
                value={searchTerm}
                onChange={(value) => {
                  setSearchFlag(true);
                  setIsLoading(true);
                  const searchValue = value;
                  setSearchTerm(searchValue);
                  if (searchValue === "") {
                    setSelectedCompany(null);
                  }
                  if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current);
                  }
                  debounceTimeout.current = setTimeout(() => {
                    getData(value, 1);
                  }, 1000);
                }}
                onSubmit={() => {
                  setSearchTerm(searchTerm);
                  getData(searchTerm, 1);
                }}
                placeholder={TEXT_COMPANY_NAME}
                size={"large"}
                label={searchTerm ? TEXT_COMPANY_NAME : ""}
              />
              {from !== "trade" && (
                <>
                  <Autocomplete
                    inputValue={roleSearchTerm}
                    onInputChange={(event, value) => {
                      if (event && event.target && typeof event.target.value === "string") {
                        let inputValue = event.target.value;
                        inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                        setRoleSearchTerm(inputValue);
                      } else {
                        setRoleSearchTerm(value);
                      }
                    }}
                    id="Roles"
                    options={roleOptions}
                    onChange={(event, value) => {
                      if (value && value.name == "Other") {
                        setShowOtherRoleInput(true);
                        setSelectedRole(value);
                      } else {
                        setShowOtherRoleInput(false);
                        setSelectedRole(value);
                      }
                    }}
                    getOptionLabel={(option) => `${option?.name}`}
                    style={{ flex: 1 }}
                    renderInput={(params) => {
                      return (
                        <TextField
                          {...params}
                          label={roleSearchTerm?.trim()?.length != 0 ? TEXT_ROLE : ""}
                          variant="outlined"
                          placeholder={TEXT_SELECT_ROLE_OPTIONAL}
                        />
                      );
                    }}
                  />
                  {showOtherRoleInput && (
                    <TextField
                      label={TEXT_NEW_ROLE}
                      variant="outlined"
                      value={otherRoleTerm}
                      onChange={(event) => {
                        let inputValue = event.target.value;
                        inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                        setOtherRoleTerm(inputValue);
                      }}
                    />
                  )}
                </>
              )}
            </Stack>
            <Box
              sx={{
                marginTop: "10px",
                paddingBottom: "10px",
                height: "300px",
                overflow: "auto",
                scrollbarWidth: "none"
              }}>
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: 300
                  }}>
                  <Loader />
                </div>
              ) : (
                <>
                  {searchFlag && (
                    <>
                      {searchTerm.trim().length > 1 && showAddBtn(searchTerm) && (
                        <Card className="pagelist-content" sx={{ marginBottom: 1 }}>
                          <ListItem disablePadding>
                            <ListItemButton onClick={() => onNewCompany(searchTerm)}>
                              <ListItemText primary={`${BUTTON_ADD} "${searchTerm}"`} />
                            </ListItemButton>
                          </ListItem>
                        </Card>
                      )}

                      {searchTerm !== "" && (
                        <>
                          {data.length > 0 && (
                            <List disablePadding>
                              <Stack gap={1}>
                                {data?.map((item, index) => {
                                  return (
                                    <Card
                                      key={index.toString()}
                                      className="pagelist-content"
                                      sx={{ marginTop: "0px" }}>
                                      <ListItem key={index.toString()} disablePadding>
                                        <ListItemButton onClick={() => onViewClick(item)}>
                                          <ListItemText primary={item?.name} />
                                        </ListItemButton>
                                      </ListItem>
                                    </Card>
                                  );
                                })}
                              </Stack>
                            </List>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </Box>
            <Stack>
              <Button
                disabled={!searchTerm || !selectedCompany}
                variant="contained"
                loading={submitLoader}
                onClick={onSaveClick}>
                {TEXT_SUBMIT}
              </Button>
            </Stack>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default AddCompanyWithRole;
